import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import { useState,useEffect } from 'react';
// import {Link} from 'react-scroll'


const NavBar=()=>{

    const [activeLink,setActiveLink] = useState('home');
    const [scrolled,setScrolled] = useState(false);

    useEffect(()=>{
        const onScroll=()=>{
            if(window.scrollY>50){
                setScrolled(true);
            }
            else{
                setScrolled(false);
            }
        }
        window.addEventListener("scroll",onscroll);
        return()=>window.removeEventListener("scroll",onscroll);

    },[])

    const onupdateActiveLink=(value)=>{
        setActiveLink(value);
    }
    return(
        <Navbar expand="lg" className={scrolled ? "scrolled": ""}>
            <Container>

                <Navbar.Brand href="#home">
                    <img src={Logo} alt="logo" className="logo" />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className='navbar-toggler-icon'></span>
                </Navbar.Toggle>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto customme-auto">
                        <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' :
                            'navbar-link'} onClick={()=>onupdateActiveLink('home')}>Home
                        </Nav.Link>
                        <Nav.Link href="#services" className={activeLink === 'services' ? 'active navbar-link' :
                            'navbar-link'} onClick={()=>onupdateActiveLink('services')}>Services
                        </Nav.Link>
                        <Nav.Link href="#products" className={activeLink === 'products' ? 'active navbar-link' :
                            'navbar-link'} onClick={()=>onupdateActiveLink('products')}>Products
                        </Nav.Link>
                        <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' :
                            'navbar-link'} onClick={()=>onupdateActiveLink('about')}>About
                        </Nav.Link>
                        <Nav.Link href="#contact" className={activeLink === 'contact' ? 'active navbar-link' :
                            'navbar-link'} onClick={()=>onupdateActiveLink('contact')}>Contact
                        </Nav.Link>
                        
                    </Nav>

                    <span className='navbar-text'>
                        <div className='social-icon'>
                            <a href="#"><img src={navIcon1} alt=""/></a>
                            <a href="#"><img src={navIcon2} alt=""/></a>
                            <a href="#"><img src={navIcon3} alt=""/></a>
                        </div>
                    </span>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    )
}

export default NavBar